<template>
  <main id='Share' v-if='kirby.page.template == "share-story"'>
    <iframe v-once title="Penn Medicine Listening Lab | Donate your Story" allowtransparency="true" allowfullscreen="true" allow="geolocation; microphone; camera" width="100%" height="100%" src="https://form.jotform.com/201934052777155" />
    <!--<section v-html='kirby.page.content.formcode.kirbytext' />-->
  </main>
</template>

<style scoped>
  iframe {
    outline: none;
    border: none;
    height: calc(100vh - 3rem);
  }
</style>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>
